import {BasePopup} from "components"
import ShiftTable from "./ShiftTable"

type Props = {
    isVisible: boolean
    onClose: () => void
    academicTrackId: number
    onRefresh: () => void
    academicTrackPhaseShiftTemplateId: number
}

const SelectShiftPopup = (props: Props) => {
    const {isVisible, onClose, onRefresh, academicTrackId, academicTrackPhaseShiftTemplateId} = props

    return isVisible ? (
        <BasePopup onCancel={onClose} isShow={isVisible} onClose={onClose} leftIcon="FILE_LINE_ALT" width="50vw">
            <ShiftTable
                onClose={onClose}
                isVisible={isVisible}
                onRefresh={onRefresh}
                academicTrackId={academicTrackId}
                academicTrackPhaseShiftTemplateId={academicTrackPhaseShiftTemplateId}
            />
        </BasePopup>
    ) : null
}

export default SelectShiftPopup
